// Main component
export { default, default as ServiceManager } from './ServiceManager.index';

// Components
export { default as ActionButtons } from './components/ActionButtons.component';
export { default as Deployments } from './components/Deployments';
export { default as StatusDot, VARIANT_TEXT_CLASS } from './components/StatusDot';

// Modals
export { default as AddServiceModal } from './modals/AddServiceModal.component';
export { default as CommandHistoryModal } from './modals/CommandHistoryModal.component';
export { default as ForceUnsafeRootModal } from './modals/ForceUnsafeRootModal';
export { default as RemoveWorkplaceModal } from './modals/RemoveWorkplaceModal';
export { default as ServiceActionModal } from './modals/ServiceActionModal.component';
export { default as ServiceDisableModal } from './modals/ServiceDisableModal';
export { default as ServiceManagerHelpModal } from './modals/ServiceManagerHelpModal';
export { default as WorkplaceFormModal } from './modals/WorkplaceFormModal';

// Hooks
export { useServices } from './hooks/ServiceManager.hooks';
export { pendingChangeKey, useWorkplaces } from './hooks/Deployments.hooks';
export type { PendingToggle, PendingWorkplaceChange } from './hooks/Deployments.hooks';

// Operations
export {
  addServiceOp,
  fetchCommandHistoryOp,
  fetchServicesOp,
  performServiceActionOp,
  removeServiceOp,
  setServiceEnabledOp,
} from './ops/ServiceManager.ops';
export type {
  CommandHistoryResult,
  FetchServicesResult,
  SetServiceEnabledResult,
} from './ops/ServiceManager.ops';

// Utils
export {
  canBeModified,
  canRestart,
  filterServicesBySearch,
  formatBytes,
  formatDelay,
  getCommandVariant,
  getStatusFromAction,
  isDisabledButRunning,
  isEnabledButNotRunning,
  isLiveNotRunning,
  isLiveStateKnown,
  isRestartOnlyService,
  liveStateView,
  mapServiceRecord,
  stateToStatus,
  toggleBlockedReason,
  toggleRowKey,
} from './utils/ServiceManager.utils';

// Config
export {
  ACTION_LABELS,
  COMMAND_OPTIONS,
  DEFAULT_APPLIES_WITHIN_MS,
  DEFAULT_REAP_WITHIN_MS,
  HISTORY_ROWS_PER_PAGE,
  LIVE_STATE_VIEW,
  MAX_REASON_LENGTH,
  PAGE_LIMIT,
  REFRESH_DELAY_MS,
  STATUS_VIEW,
  RESTART_ONLY_SERVICE_PATTERNS,
  SYSTEM_SERVICE_PATTERNS,
} from './config/ServiceManager.config';

// Types
export type {
  ActionButtonConfig,
  ActionLabelConfig,
  CommandHistoryParams,
  CommandHistoryRow,
  CommandType,
  EllipsisOpenState,
  LiveStateView,
  PendingAction,
  RawService,
  ServiceAction,
  ServiceControl,
  ServiceRecord,
  ServiceScope,
  ServiceState,
  ServiceStatus,
  StatusVariant,
} from './types/ServiceManager.types';

export type {
  AddWorkplacePayload,
  AddWorkplaceRequest,
  GlobalService,
  ServiceRuntime,
  ServiceRuntimeState,
  ServiceToggleAction,
  ServiceTogglePayload,
  SupervisorRestartPayload,
  ToggleOutcome,
  ToggleTarget,
  UpdateWorkplaceRequest,
  Workplace,
  WorkplaceMode,
  WorkplaceMutationPayload,
  WorkplaceService,
  WorkplacesPayload,
} from './types/Deployments.types';
